/* La cronistoria di un record nato da una campagna, detta in italiano.

   I fatti stanno sul record (`campagna_prova`, scritto dal motore): qui diventano frasi.
   Serve soprattutto ai due RECUPERI, dove il numero in archivio non e' quello che la
   campagna aveva dato — chi guarda il record fra un anno deve capirlo al volo.
   Funzioni pure, provate a tavolino. */

const TITOLI = {
  maschera: 'Numero ricostruito dalla campagna',
  numero_diverso: 'Numero diverso da quello della campagna',
  piva_confermata: 'Azienda confermata dalla partita IVA del sito',
  piva_non_pubblicata: 'Partita IVA non pubblicata: azienda riconosciuta dal nome',
  // liste da import: nessuna maschera e nessuna partita IVA, la prova e' chi ha risposto
  nome_e_comune: 'Azienda riconosciuta per nome e comune',
  cellulare_combacia: 'Azienda riconosciuta dal cellulare della lista',
};

/** Il titolo del riquadro. */
export function titoloProva(prova) {
  return TITOLI[(prova || {}).esito] || 'Da campagna';
}

/** True se il numero in archivio NON e' quello dato dalla campagna (va detto forte). */
export function eRecupero(prova) {
  const e = (prova || {}).esito;
  return e === 'numero_diverso' || e === 'piva_non_pubblicata';
}

const IDENTITA = { nome: 'per nome', comune: 'per comune', nessuna: 'in nessun modo' };

/** Le righe della cronistoria, nell'ordine in cui si leggono. */
export function frasiProva(prova) {
  const p = prova || {};
  if (!p.esito) return [];
  const righe = [];
  const lista = p.tipo === 'cerved' ? 'Da lista CERVED'
    : p.tipo === 'generica' ? 'Da lista importata' : 'Da lista TIM';
  righe.push(`${lista}${p.at ? ` · indagata il ${data(p.at)}` : ''}.`);

  if (p.numero_campagna) {
    const cifre = p.numero_campagna_cifre ? ` (${p.numero_campagna_cifre} cifre)` : '';
    righe.push(p.esito === 'maschera'
      ? `Il numero della campagna era ${p.numero_campagna}${cifre} e il numero trovato combacia con le cifre visibili.`
      : `Il numero della campagna era ${p.numero_campagna}${cifre} e non è stato ritrovato.`);
  }
  if (p.esito === 'numero_diverso') {
    righe.push(`Su Maps l’azienda combacia ${IDENTITA[p.identita] || ''}${p.maps_nome ? ` (${p.maps_nome})` : ''}`
      + `${p.stesso_distretto ? ' e il numero trovato è dello stesso distretto telefonico' : ''}: `
      + 'probabile cambio di numero.');
  }
  if (p.esito === 'piva_confermata') {
    righe.push(`Sul sito la partita IVA è quella dell’azienda${p.piva_sito ? ` (${p.piva_sito})` : ''}.`);
  }
  if (p.esito === 'piva_non_pubblicata') {
    righe.push('Sul sito la partita IVA non è pubblicata, ma il nome combacia su Maps'
      + `${p.maps_nome ? ` (${p.maps_nome})` : ''}`
      + `${p.telefono_etichettato ? ' e il numero è quello indicato come «Tel.» sul sito' : ''}.`);
  }
  if (p.esito === 'nome_e_comune') {
    righe.push('Nella lista non c’era un numero da verificare: l’azienda è stata ritrovata su Maps'
      + `${p.maps_nome ? ` (${p.maps_nome})` : ''} per nome e comune`
      + `${p.telefono_etichettato ? ', e il numero è quello indicato come «Tel.» sul sito' : ''}.`);
  }
  if (p.esito === 'cellulare_combacia') {
    righe.push('Il nome su Maps non combaciava, ma il cellulare che la lista aveva è scritto '
      + `online${p.maps_nome ? ` sulla scheda di ${p.maps_nome}` : ''}: un numero non ha omonimi.`);
  }
  if (p.numero_trovato) righe.push(`Numero portato in archivio: ${p.numero_trovato}.`);
  return righe;
}

function data(iso) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('it-IT');
}
